module.exports = __webpack_public_path__ + "static/media/icon-email-comm-log.7e723300.svg";